const toLocalDateKey = (date) =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");

export const addTemplateDays = (dateKey, days) => {
  const [year, month, day] = dateKey.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return toLocalDateKey(date);
};

const normalizeTemplateCategory = (category) => {
  if (["train", "plane", "car"].includes(category)) return "movement";
  if (["nature", "shopping"].includes(category)) return "sightseeing";
  return ["hotel", "restaurant", "sightseeing", "movement", "activity"].includes(category)
    ? category
    : "activity";
};

export const createTemplateSchedulePayloads = ({
  template,
  shioriId,
  startDate,
  members = [],
}) => {
  if (!template || !shioriId || !startDate) return [];

  const scheduleMembers = members
    .map((member) => member.MEMBER_CODE)
    .filter(Boolean)
    .map((memberCode) => ({
      member_code: memberCode,
      split_participate_flg: "1",
    }));

  return template.schedules.map((item) => {
    const date = addTemplateDays(startDate, item.day);
    return {
      shioriId,
      title: item.title,
      startDate: date,
      startTime: item.startTime,
      endDate: date,
      endTime: item.endTime,
      timeDifference: "9",
      category: normalizeTemplateCategory(item.category),
      url: item.url || null,
      transportation: item.transportation || null,
      tel: item.tel || "",
      address: item.address || null,
      googlePlaceNmv: item.googlePlaceNmv || null,
      googlePlaceId: item.googlePlaceId || null,
      latitude: item.latitude ?? null,
      longitude: item.longitude ?? null,
      remarks: item.remarks || null,
      cost: item.cost ?? null,
      currency: item.currency || "JPY",
      reservation: Boolean(item.reservation),
      needFlg: item.needFlg !== false,
      reservationDone: Boolean(item.reservationDone),
      paidBy: item.paidBy || null,
      members: scheduleMembers,
    };
  });
};

export const createTemplateSchedulesWithRollback = async ({
  payloads,
  createSchedule,
  finalize,
  rollback,
}) => {
  try {
    for (const payload of payloads) {
      await createSchedule(payload);
    }
    if (finalize) await finalize();
  } catch (error) {
    try {
      await rollback();
    } catch (rollbackError) {
      console.error("テンプレートしおりのロールバックエラー:", rollbackError);
      error.rollbackError = rollbackError;
    }
    throw error;
  }
};

export const fetchTemplateImageFile = async (template, fetchImpl = fetch) => {
  const response = await fetchImpl(template.imageUrl);
  if (!response.ok) throw new Error("テンプレート画像を取得できませんでした");
  const blob = await response.blob();
  if (!blob.size || !blob.type.startsWith("image/")) {
    throw new Error("テンプレート画像が不正です");
  }
  return new File([blob], `${template.id}.webp`, {
    type: blob.type || "image/webp",
  });
};

export const resolveShioriImageUrl = (shiori, apiUrl) => {
  if (!shiori?.HAS_IMAGE) return "";
  if (String(shiori.IMAGE_DATA_URI || "").startsWith("data:image/")) {
    return shiori.IMAGE_DATA_URI;
  }
  if (shiori.__guest && /^\/(?!\/)/.test(shiori.IMAGE_URL || "")) {
    return shiori.IMAGE_URL;
  }
  return shiori.SHIORI_NOV
    ? `${apiUrl}/shiori/${shiori.SHIORI_NOV}/image`
    : "";
};
